/* @flow */

import $ from 'jquery';
import modalConfirmacao from '../utils/modal-confirmacao';

const modalHabilitarTodosFuncionamentos = (el: Element) => {
    modalConfirmacao({
        titulo: 'Deseja habilitar todos os horários de funcionamento?',
        texto: 'O horário de funcionamento não pode ficar vazio.',
        tamanho: 'md',
        sim: 'Habilitar',
        nao: 'Cancelar',
        timeout: 100000,
    }).then(() => {
        $('input[name="funcionamentosId[]"]').prop('checked', true);
    }).catch(() => {
        $(el).prop('checked', true);
    });
};

export default modalHabilitarTodosFuncionamentos;
